import DOMPurify from 'dompurify';

class SanitizeUtils {
    private static allowedProperties = [
        'align-content',
        'align-items',
        'background-color',
        'border',
        'border-radius',
        'border-color',
        'border-width',
        'color',
        'font-weight',
        'font-size',
        'font-family',
        'font-style',
        'justify-content',
        'justify-items',
        'line-height',
        'letter-spacing',
        'margin',
        'padding',
        'text-align',
        'text-decoration',
        'vertical-align',
    ];

    static sanitizeStyle(style: string): string {
        return style
            .split(';')
            .map(s => s.trim())
            .filter(rule => {
                const [prop] = rule.split(':');
                return SanitizeUtils.allowedProperties.includes(prop?.trim());
            })
            .join('; ');
    }

    static initStyleHook(): void {
        // Prevent duplicate hook registrations
        if (!(DOMPurify as any)._styleHookInitialized) {
            DOMPurify.addHook('afterSanitizeAttributes', (node, data, config) => {
                const htmlNode = node as HTMLElement;
                if (htmlNode.hasAttribute('style')) {
                    const sanitized = SanitizeUtils.sanitizeStyle(htmlNode.getAttribute('style') || '');
                    htmlNode.setAttribute('style', sanitized);
                }
            });
            (DOMPurify as any)._styleHookInitialized = true; // internal guard
        }
    }

    static sanitizeHtml(html: string): TrustedHTML {
        SanitizeUtils.initStyleHook();

        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: [
                'a', 'b', 'i', 'em', 'strong', 'p', 'br', 'div', 'span',
                'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'video', 'audio', 'source'
            ],
            ALLOWED_ATTR: ['href', 'target', 'style', 'class', 'src', 'type', 'controls', 'autoplay', 'loop', 'muted', 'preload', 'poster'],
            ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data:(?:image\/(?:png|jpeg|gif)|audio\/(?:mpeg|ogg)|video\/(?:mp4|ogg|webm));base64,):)/i,
            FORBID_TAGS: ['script'],
            RETURN_TRUSTED_TYPE: true,
        });
    }

    static sanitizeUrl = (str: string): string => {
        const clean = str.trim();

        if (/^https?:\/\//i.test(clean)) {
            return clean;
        }

        return `https://${clean}`;
    }
}

export default SanitizeUtils;
